import LegalLayout, { LegalSection } from "@/components/site/LegalLayout";
import { BRAND } from "@/lib/brand";
import SEO from "@/components/SEO";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updatedAt="June 2026" testid="privacy-page">
      <SEO title="Privacy Policy" description="How Greinch WW LLC collects, uses and protects personal data." path="/privacy" />
      <p>
        This Privacy Policy explains how {BRAND.name} ("GREINCH", "we", "us" or "our") collects,
        uses, shares and protects information about you when you visit our website, contact us,
        or engage with our development and brokerage services.
      </p>

      <LegalSection heading="1. Information we collect">
        <p>We collect information you provide directly, such as:</p>
        <ul className="list-disc list-outside pl-5 space-y-1">
          <li>Identification data: name, work email, company, phone, country.</li>
          <li>Project information you choose to share through forms or email.</li>
          <li>Communications you exchange with our team.</li>
        </ul>
        <p>
          We also collect limited technical information automatically (IP address, browser, device,
          pages viewed) through cookies and similar technologies. See our{" "}
          <a href="/cookies" className="text-coral hover:underline">Cookies Policy</a> for details.
        </p>
      </LegalSection>

      <LegalSection heading="2. How we use information">
        <ul className="list-disc list-outside pl-5 space-y-1">
          <li>To respond to enquiries and deliver requested information or proposals.</li>
          <li>To provide, operate and improve our development and brokerage services.</li>
          <li>To comply with legal obligations and protect our legitimate interests.</li>
          <li>To send relevant communications about our services (you can opt-out at any time).</li>
        </ul>
      </LegalSection>

      <LegalSection heading="3. Legal basis (GDPR / similar laws)">
        <p>
          Where applicable, we rely on: your consent, the performance of a contract with you,
          compliance with a legal obligation, and our legitimate interests in operating and
          promoting our business.
        </p>
      </LegalSection>

      <LegalSection heading="4. Sharing of information">
        <p>
          We do not sell personal information. We may share information with:
        </p>
        <ul className="list-disc list-outside pl-5 space-y-1">
          <li>Service providers that support us (hosting, analytics, communication tools), under strict confidentiality.</li>
          <li>Authorities or third parties when required by law or to protect rights and safety.</li>
          <li>Vetted partners involved in a brokerage engagement — only with your explicit instruction.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="5. International transfers">
        <p>
          As an international operation, your information may be transferred and processed outside
          your country of residence. We apply appropriate safeguards in line with applicable laws.
        </p>
      </LegalSection>

      <LegalSection heading="6. Data retention">
        <p>
          We retain personal information only for as long as necessary for the purposes described
          in this policy, or as required by law.
        </p>
      </LegalSection>

      <LegalSection heading="7. Your rights">
        <p>
          Depending on your jurisdiction, you may have the right to access, correct, delete or
          restrict the use of your personal data, to object to processing, and to data portability.
          You may also withdraw consent at any time.
        </p>
      </LegalSection>

      <LegalSection heading="8. Security">
        <p>
          We apply reasonable technical and organisational measures to protect your information.
          However, no method of transmission or storage is 100% secure.
        </p>
      </LegalSection>

      <LegalSection heading="9. Contact">
        <p>
          For any privacy enquiry, contact us at{" "}
          <a href={`mailto:${BRAND.email}`} className="text-coral hover:underline">
            {BRAND.email}
          </a>{" "}
          or write to:
        </p>
        <p>
          {BRAND.name}<br />
          {BRAND.address}<br />
          {BRAND.addressLine2}
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
